import { HttpHeaders } from '@angular/common/http';


export interface IHttpOptions {
  Headers?: HttpHeaders;
  RequestType?: requestType;
  RequestServer?: requestServer;
}
export enum requestType {
  Protected,
  Anonymus,
  Guest
}
export enum requestServer {
  ApiServer,
  AuthServer,
  Other
}
export interface IApiResponse {
  response: string;
  failure: IApiError;
  success: _IApiSuccess;
}
export interface IApiError {
  code: number | string;
  message: string;
  description: string;
  trace: string;
}
export interface _IApiSuccess {
  code: number;
  message: String;
  result: any;
}
export interface IApiSuccess<T> {
  code: number;
  message: String;
  result: T;
}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/interface/IHttpServices.ts